import { render, staticRenderFns } from "./BasicInfo.vue?vue&type=template&id=55298a7e&scoped=true"
import script from "./BasicInfo.vue?vue&type=script&lang=js"
export * from "./BasicInfo.vue?vue&type=script&lang=js"
import style0 from "./BasicInfo.vue?vue&type=style&index=0&id=55298a7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55298a7e",
  null
  
)

export default component.exports